import { listCatalog, type CatalogItem } from './api-parity';
import type { Outcome } from './api';

export type CatalogKind = 'projects' | 'clients';

/**
 * A fixed list for the pickers until core-api's catalogue lands (#915 P1): finance answers 503
 * `CATALOG_UNAVAILABLE` until then. Development only; finance still checks what is saved.
 */
const FAKE: Record<CatalogKind, readonly CatalogItem[]> = {
  projects: [
    { id: '0b6f5a52-5d1c-4f43-9a8e-1f2b3c4d5e01', code: 'P-0142', name: 'Studio ORBIT' },
    { id: '0b6f5a52-5d1c-4f43-9a8e-1f2b3c4d5e02', code: 'P-0151', name: 'Registro EPI-2' },
    { id: '0b6f5a52-5d1c-4f43-9a8e-1f2b3c4d5e03', code: 'P-0163', name: 'Registro cardio REG-3' },
    { id: '0b6f5a52-5d1c-4f43-9a8e-1f2b3c4d5e04', code: 'P-0170', name: 'Studio NEURO-4' },
  ],
  clients: [
    { id: '1c7a6b63-6e2d-4054-8b9f-2a3b4c5d6e01', code: 'C-021', name: 'Ospedale di Padova' },
    { id: '1c7a6b63-6e2d-4054-8b9f-2a3b4c5d6e02', code: 'C-034', name: 'Fondazione Ricerca Nord' },
  ],
};

/** True only where the flag is set and the build is not production's. */
export function catalogFakeOn(env: {
  MODE?: string;
  VITE_EXPENSES_CATALOG_FAKE?: string;
}): boolean {
  return env.VITE_EXPENSES_CATALOG_FAKE === '1' && env.MODE !== 'production';
}

/** The organization's active projects or clients, for the note form's pickers. */
export function loadCatalog(
  kind: CatalogKind,
  fake = catalogFakeOn(import.meta.env),
): Promise<Outcome<CatalogItem[]>> {
  if (fake) return Promise.resolve({ ok: true, value: [...FAKE[kind]] });
  return listCatalog(kind);
}
